import { createSceneReducer } from 'reducers/reducers-util';
import recentActivityDataReducer from 'components/admin/recent-activity/store/reducers.data';

export default createSceneReducer(recentActivityDataReducer);



// WEBPACK FOOTER //
// ./src/components/admin/recent-activity/store/reducers.js